'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { Box } from '@wishket/design-system';

import { useGetThreePopularArticles } from '@/entities/article';
import { Skeleton } from '@/shared/Components';

const ArticleSuggestionsClient = dynamic(
  () => import('@/features/Article').then((mod) => mod.ArticleSuggestions),
  { ssr: false }
);

interface PopularArticlesProps {
  articleId?: string;
}

const PopularArticles = ({ articleId }: PopularArticlesProps) => {
  const { data: popularArticles } = useGetThreePopularArticles(articleId);

  if (!popularArticles)
    return (
      <Box className="flex w-full gap-6">
        {Array(3)
          .fill(null)
          .map((_, index) => (
            <Skeleton key={index} className="h-[302px]" />
          ))}
      </Box>
    );

  return (
    <Suspense
      fallback={
        <Box className="flex w-full gap-6">
          {Array(3)
            .fill(null)
            .map((_, index) => (
              <Skeleton key={index} className="h-[302px]" />
            ))}
        </Box>
      }
    >
      <ArticleSuggestionsClient
        title="인기 있는 콘텐츠"
        items={popularArticles}
      />
    </Suspense>
  );
};

export default PopularArticles;
